(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["predictive-search"]) return;
  try {
    
  const config = {
    childList: true,
  };
  const form = document.querySelector('#predictive-search form');
  const formResults = document.querySelector('#predictive-search-results');

  const callback = (mutationList, observer) => {
    for (const mutation of mutationList) {
      if (mutation.type === 'childList') {
        const formBtn = formResults.querySelector('#predictive-search--submit');
        if (formBtn) {
          formBtn.addEventListener('click', (event) => {
            form.submit();
          });
        }
      }
    }
  };
  const observer = new MutationObserver(callback);
  observer.observe(formResults, config);

  } catch(e) { console.error(e); }
})();
})();
